"use client"

import React, { useState, useEffect } from 'react';
import { ListItem } from './components/ListItem';
import { Item, ListProps } from '@/types';

interface ControllableListProps extends ListProps {
  defaultSelectedIndex?: number | null;
}

export const List: React.FC<ControllableListProps> = ({ items, onItemClick, defaultSelectedIndex = null, preventDeselection = false }) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(defaultSelectedIndex);

  useEffect(() => {
    setSelectedIndex(defaultSelectedIndex);
  }, [defaultSelectedIndex]);

  const handleItemClick = (item: Item, index: number) => {
    if (preventDeselection && selectedIndex === index) {
      return;
    }
    setSelectedIndex(index === selectedIndex ? null : index);
    if (onItemClick) {
      onItemClick(item);
    }
  };

  return (
    <ul className="flex flex-col overflow-scroll max-h-[40vh]">
      {items.map((item: Item, index: number) => (
        <ListItem
          key={index}
          icon={item.icon}
          isSelected={index === selectedIndex}
          onClick={() => handleItemClick(item, index)}
        >
          {item.text}
        </ListItem>
      ))}
    </ul>
  );
};